export default "__VITE_ASSET__d8685e89__"